export const getFullImageUrl = (url) => {
  if (!url) return '';
  if (url.startsWith('http')) return url;
  if (url.startsWith('/uploads')) return `http://localhost:5000${url}`;
  return url;
};

export const formatDate = (date) => {
  if (!date) return '';
  return new Date(date).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  });
};

export const formatDateTime = (date) => {
  if (!date) return '';
  return new Date(date).toLocaleString();
};

export const truncateText = (text, maxLength = 50) => {
  if (!text) return '';
  if (text.length <= maxLength) return text;
  return text.substring(0, maxLength) + '...';
};

export const arrayToText = (arr) => {
  if (!arr || !Array.isArray(arr)) return '';
  return arr.join('\n');
};

export const textToArray = (text) => {
  if (!text) return [];
  return text.split('\n').filter(item => item.trim());
};

export const getStatusBadge = (isActive) => {
  return {
    bg: isActive ? '#D4EDDA' : '#F8D7DA',
    color: isActive ? '#155724' : '#721C24',
    text: isActive ? 'Active' : 'Inactive'
  };
};

export const validateImage = (file) => {
  if (!file) return { valid: false, error: 'No file selected' };
  if (file.size > 5 * 1024 * 1024) return { valid: false, error: 'File size must be less than 5MB' };
  if (!file.type.startsWith('image/')) return { valid: false, error: 'File must be an image' };
  return { valid: true, error: null };
};